import type { ReactNode } from 'react';

export const symbol_home_storage: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M251-120q-21.66 0-38.46-14.18Q195.73-148.36 192-170l-66-395q-2-14 6.49-24.5T155-600h650q14.02 0 22.51 10.5Q836-579 834-565l-66 395q-3.73 21.64-20.54 35.82Q730.66-120 709-120H251Zm-58-420 57 360h460l57-360H193Zm207 160h160q12.75 0 21.38-9 8.62-9 8.62-21.5t-8.62-21Q572.75-440 560-440H400q-12 0-21 8.62-9 8.63-9 21.38 0 12 9 21t21 9ZM240-660q-12 0-21-9t-9-21.5q0-12.5 9-21t21-8.5h480q12.75 0 21.38 8.62Q750-702.75 750-690q0 12-8.62 21-8.63 9-21.38 9H240Zm80-120q-12 0-21-9t-9-21.5q0-12.5 9-21t21-8.5h320q12.75 0 21.38 8.62Q670-822.75 670-810q0 12-8.62 21-8.63 9-21.38 9H320Zm-70 600h460-460Z"
		/>
	</svg>
);
